import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { formatDate, formatMoney } from "../Helpers";

export default function View({ data }) {

	const appContext = useContext(AppContext);

	/* Place states here */

	function viewRecord() {
		return;
		appContext.navTo({
			item: 'side-view',
			subItem: 'discount-options',
			extraItem: data.uuid,
		})
	}

	

	return (
		<div className="One" onClick={viewRecord} >
			<div className="row">

				<div className="col-12">
					<h6
						style={{
							fontSize: "14px"
						}}
						className="font-semi-bold"
					>
						{data.title}
					</h6>

					
					
				</div>

				<div className="col-8">
					<h6
						style={{
							fontSize: "14px"
						}}
						className="font-bold text-success"
					>
						TZS {formatMoney(data.amount)}
					</h6>
				</div>
				
				<div className="col-4">
					<h6
						style={{
							fontSize: "12px"
						}}
						className=""
					>
						

						{formatDate(data.dateCreated)}
					</h6>
				</div>
				

			</div>
		</div>
	)

}